import tokens from './tokens';

const theme = {
  borderRadius: {
    xsmall: '2px',
    small: '4px',
    default: '6px',
    large: '8px',
  },
  boxShadow: {
    default: tokens.boxShadow.default,
    xsmall: tokens.boxShadow.xsmall,
    small: tokens.boxShadow.small,
    medium: tokens.boxShadow.medium,
    mediumInverted: tokens.boxShadow.mediumInverted,
    large: tokens.boxShadow.large,
  },
  fontFamily: {
    default: 'Inter, Arial, sans-serif',
  },
  fontSize: {
    small: tokens.fontSize.small,
    reduced: tokens.fontSize.reduced,
    base: tokens.fontSize.base,
    medium: tokens.fontSize.medium,
    large: tokens.fontSize.large,
    xlarge: tokens.fontSize.xlarge,
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    mediumHeavy: 600,
    heavy: 700,
  },
  iconSize: {
    xsmall: '16px',
    small: '24px',
    medium: '32px',
    large: '48px',
  },
  lineHeight: {
    base: '1.62',
    controls: '16px',
  },
  overlay: {
    backdropFilter: 'blur(4px)',
    color: tokens.overlay.color,
  },
  spacing: {
    insetSmall: '8px',
    insetMedium: '16px',
    insetLarge: '24px',
    insetXLarge: '32px',
    insetXXLarge: '48px',

    stackXSmall: '4px',
    stackSmall: '8px',
    stackMedium: '16px',
    stackLarge: '24px',
    stackXLarge: '32px',

    inlineSmall: '8px',
    inlineMedium: '16px',
    inlineLarge: '24px',
    inlineXLarge: '32px',

    xsmall: '2px',
    small: '4px',
    medium: '8px',
    large: '16px',
    xlarge: '32px',
  },
  colors: tokens.colors,
  transitions: {
    fast: '75ms ease-in-out',
  },
  zIndex: {
    top: 999999,
  },
};

theme.lineGraphColors = {
  lineGraphLine0: theme.colors.purple400,
  lineGraphLine1: theme.colors.red300,
  lineGraphLine2: theme.colors.yellow300,
  lineGraphLine3: theme.colors.red700,
  lineGraphLine4: theme.colors.green300,
};

theme.windowWidth = {
  small: 1366,
};

export default theme;
